import axios from 'axios'

// Set axios defaults
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
axios.defaults.timeout = 10 * 60 * 1000 // 10 mins
